<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <!-- <pre>debug: {{config.snippet.profile.default}} </pre> -->
        <b-row>
            <b-col sm=12>
                <b-card border-variant="light">
                    <div slot="header">
                        <strong>LTE</strong>
                    </div>
                    <div>
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-form-group label="APN:" label-for="default_apn">

                                <b-form-input type="text" v-model="config.snippet.profile.default.default.apn" v-validate.initial="''" id="default_apn" name="APN" class="form-control" :class="{'is-invalid': submitted && verrors.has('APN') }" :disabled=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('APN')" class="invalid-feedback">{{ errors.first('APN') }}</div>
                            </b-form-group>
                            <b-form-group label="LTE Username:" label-for="default_user">
                                <b-form-input type="text" v-model="config.snippet.profile.default.default.user" v-validate.initial="''" id="default_user" name="LTE User" class="form-control" :class="{'is-invalid': submitted && verrors.has('User') }" :disabled=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('LTE User')" class="invalid-feedback">{{ errors.first('LTE User') }}</div>
                            </b-form-group>
                            <b-form-group label="LTE Password:" label-for="default_passw">
                                <b-form-input type="text" v-model="config.snippet.profile.default.default.passw" v-validate.initial="''" id="default_passw" name="LTE Password" class="form-control" :class="{'is-invalid': submitted && verrors.has('LTE Password') }" :disabled=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('LTE Password')" class="invalid-feedback">{{ errors.first('LTE Password') }}</div>
                            </b-form-group>
                            <b-form-group label="LTE PIN:" label-for="default_pincode">
                                <b-form-input type="text" v-model="config.snippet.profile.default.default.pincode" v-validate.initial="''" id="default_passw" name="LTE PIN" class="form-control" :class="{'is-invalid': submitted && verrors.has('LTE PIN') }" :disabled=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('LTE PIN')" class="invalid-feedback">{{ errors.first('LTE PIN') }}</div>
                            </b-form-group>
                            <b-form-group label="LTE Authentication Protocol:" label-for="default_auth">
                                <b-form-select key="LTE Authentication Protocol" v-model="config.snippet.profile.default.default.auth" :options="authOptions" v-validate="" id="default_auth" name="LTE Authentication Protocol" class="form-control" :class="{'is-invalid': submitted && verrors.has('LTE Authentication Protocol') }" :disabled=!readonly>
                                </b-form-select>
                            </b-form-group>
                            <div class="text-center">
                                <!-- TODO only activate when dirty -->
                                <button v-if="readonly" :disabled="verrors.any()" class="btn btn-primary">Add</button>
                                <!--  <b-button type="reset" variant="danger">Reset</b-button> -->
                                <!-- <button @click.prevent="reRender">Reset</button> -->
                            </div>
                        </b-form>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import Tasks from "@/readynet/configs/network/Tasks";

export default {
    components: {
        ValidationProvider,
        Multiselect,
        Tasks,
    },
    props: {
        config: {
            type: Object,
            required: true,
        },

        changed: {
            type: Array,
        },
        changes: {
            type: Object,
        },
    },

    data() {
        return {
            loading: false,
            submitted: false,
            authOptions: [
                { text: 'None', value: "0" },
                { text: 'PPP', value: "1" },
                { text: 'CHAP', value: "2" },
            ],

        }
    },

    methods: {

        mounted() {},
        updateChanged(par, val, nam) {
            for (var i = this.changed.length - 1; i >= 0; i--) {
                if (this.changed[i].param === par) {
                    this.changed.splice(i, 1);
                }
            }
            this.changed.push({ param: par, value: val, name: nam })
            this.$set(this.changes, par, val)
        },

        onSubmit() {
            this.submitted = true;
            // console.log("Invalid " + (this.$validator.fields).map(field => field.flags.invalid))
            // console.log("Dirty " + (this.$validator.fields).map(field => field.flags.dirty))
            // console.log("IP dirty " + this.veeFields['LAN IP'].dirty);
            // console.log("netmask dirty " + this.veeFields['LAN Netmask'].dirty);

            // Object.keys(this.veeFields).every(field => {
            //   if (this.veeFields[field].dirty) {
            //     console.log("MSG:", this.veeFields[field] + " ", field)

            //   }
            // });

            this.$validator.validate().then(valid => {

                if (valid) {
                    // need to simplify this
                    if (this.veeFields['APN'].dirty) {
                        this.updateChanged("default_apn", this.config.snippet.profile.default.default.apn, "LTE APN")
                    }
                    if (this.veeFields['LTE User'].dirty) {
                        this.updateChanged("default_user", this.config.snippet.profile.default.default.user, "LTE User")
                    }
                    if (this.veeFields['LTE Password'].dirty) {
                        this.updateChanged("default_passw", this.config.snippet.profile.default.default.passw, "LTE Password")
                    }
                    if (this.veeFields['LTE PIN'].dirty) {
                        this.updateChanged("default_pincode", this.config.snippet.profile.default.default.pincode, "LTE PIN")
                    }
                    if (this.veeFields['LTE Authentication Protocol'].dirty) {
                        this.updateChanged("default_auth", this.config.snippet.profile.default.default.auth, "LTE Authentication Protocol")
                    }

                    // this.$router.push("/#/devices");
                } else {
                    console.log("LAN submitted, INVALID");
                }
            });
        },

    }, // end methods
    computed: {
        readonly() {
            return this.$can('config','edit')
        },
    },
};
</script>
// isFormValid () { // // loop over all contents of the fields object and check if they exist and valid or valid == null. // return Object.keys(this.veeFields).every(field => { // return this.veeFields[field] && (this.veeFields[field].valid || (this.veeFields[field].valid == null)); // }); // } // toArray(obj_obj) { // return Object.keys(obj_obj).map(i => obj_obj[i]); // }, // computed:{ // local: { // get() { // return this.params // }, // set(val) { // // this.$emit('input', val) // } // }, // }, // watch:{ // params:{ // // deep: true, // handler(){ // this.my = this.params // } // }, // },
